export default __webpack_public_path__ + "static/media/faquser.e821fdee.svg";